import React from "react";
import { useAtom } from "jotai";
import { motion } from "framer-motion";
import { themeAtom } from "../../../../../-Atoms";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const JobSpecificationsV2 = ({ jobData, clientData }) => {
  const [theme] = useAtom(themeAtom);

  // Payment terms mapping for display values
  const getPaymentTermsLabel = (value) => {
    if (!value) return "Payment Terms";
    if (value.toLowerCase() === "cod") return "COD";
    return "Payment Terms";
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
  };

  return (
    <motion.div variants={itemVariants}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: "10px",
          backgroundColor:
            theme === "dark" ? "rgba(35,35,35,0.7)" : "rgba(235,235,235,0.9)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow:
            theme === "dark"
              ? "0 2px 10px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)"
              : "0 2px 10px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.5)",
          padding: 2,
          marginBottom: 2,
        }}
      >
        
        <Box sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}>
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            label="Payment Terms"
            disabled={true}
            variant="filled"
            value={getPaymentTermsLabel(clientData?.paymentTerms)}
            size="small"
            sx={{
              flex: "1 1 47%",
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
            InputProps={{ disableUnderline: true }}
          />
          
          <TextField
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            label="Production Fee"
            disabled={true}
            variant="filled"
            value={`${clientData.PSF || 0}%`}
            size="small"
            sx={{ 
              flex: "1 1 47%", 
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
            InputProps={{ disableUnderline: true }}
          />
          
          <TextField
            variant="filled"
            label="Full Day Images"
            value={clientData.fullDayRate?.images || ""}
            disabled={true}
            size="small"
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            InputProps={{ disableUnderline: true }}
            sx={{ 
              flex: "1 1 47%", 
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
          />
          
          <TextField
            variant="filled"
            label="Half Day Images"
            value={clientData.halfDayRate?.images || ""}
            disabled={true}
            size="small"
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            InputProps={{ disableUnderline: true }}
            sx={{ 
              flex: "1 1 47%", 
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
          />
          
          <TextField
            variant="filled"
            label="Content Full Day Images"
            value={clientData.contentFullDayRate?.images || ""}
            disabled={true}
            size="small"
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            InputProps={{ disableUnderline: true }}
            sx={{ 
              flex: "1 1 47%", 
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
          />
          
          <TextField
            variant="filled"
            label="Content Half Day Images"
            value={clientData.contentHalfDayRate?.images || ""}
            disabled={true}
            size="small"
            inputProps={{ style: { fontSize: 15 } }}
            InputLabelProps={{ style: { fontSize: 15 } }}
            InputProps={{ disableUnderline: true }}
            sx={{ 
              flex: "1 1 47%", 
              minWidth: "200px",
              "& .MuiFilledInput-root": {
                borderRadius: "8px",
                backgroundColor:
                  theme === "dark"
                    ? "rgba(45,45,45,0.7)"
                    : "rgba(250,250,250,0.9)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(55,55,55,0.8)"
                      : "rgba(255,255,255,1)",
                },
                "&.Mui-focused": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(60,60,60,0.9)"
                      : "rgba(255,255,255,1)",
                  boxShadow:
                    theme === "dark"
                      ? "0 0 0 2px rgba(100,100,255,0.5)"
                      : "0 0 0 2px rgba(100,100,255,0.3)",
                },
              },
            }}
          />
        </Box>
      </Box>
    </motion.div>
  );
};

export default JobSpecificationsV2;